import { Paper } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import AdminHeader from '../global/Header'
import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer,
  } from 'recharts';

  const data = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 8,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 18,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];


const Barchart = () => {
  return (
    <>
    <Box margin="20px" >
    <AdminHeader title="Bar Chart" subtitle="Barchart With minimum height " />
    <Paper elevation={4} sx={{backgroundColor:'white' ,marginTop:'25px',borderRadius:3,padding:"35px"}} >
    <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" >
        <BarChart
          width={900}
          height={500}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="pv" fill="#8884d8" minPointSize={5}>
          </Bar>
          <Bar dataKey="uv" fill="#82ca9d" minPointSize={10} />
        </BarChart>
       </Box>
      </Paper>
    </Box>
    </>
  )
}

export default Barchart
